export default function initUniversalPlayer() {
  const players = document.querySelectorAll(".js-audio-player")

  if (!players.length) return

  players.forEach((player) => {
    const audio = player.querySelector("audio")
    const totalTimeEl = player.querySelector(".js-total-time")

    const playBtn = player.querySelector(".js-play-btn")
    const iconPlay = playBtn ? playBtn.querySelector(".icon-play") : null
    const iconPause = playBtn ? playBtn.querySelector(".icon-pause") : null

    const volumeBtn = player.querySelector(".js-volume-btn")
    const volumePopup = player.querySelector(".js-volume-popup")
    const volumeRange = player.querySelector(".js-volume-range")

    const formatTime = (seconds) => {
      if (!seconds || isNaN(seconds)) return "0:00"
      const min = Math.floor(seconds / 60)
      const sec = Math.floor(seconds % 60)
      return `${min}:${sec < 10 ? "0" + sec : sec}`
    }

    if (totalTimeEl && audio) {
      audio.addEventListener("loadedmetadata", () => {
        totalTimeEl.textContent = formatTime(audio.duration)
      })
      if (audio.readyState >= 1) {
        totalTimeEl.textContent = formatTime(audio.duration)
      }
    }

    if (iconPlay && iconPause && audio) {
      audio.addEventListener("play", () => {
        iconPlay.style.display = "none"
        iconPause.style.display = "block"
      })

      audio.addEventListener("pause", () => {
        iconPlay.style.display = "block"
        iconPause.style.display = "none"
      })

      audio.addEventListener("ended", () => {
        iconPlay.style.display = "block"
        iconPause.style.display = "none"
      })
    }

    if (volumeBtn && volumePopup && volumeRange && audio) {
      volumeBtn.addEventListener("click", (e) => {
        e.stopPropagation()

        document.querySelectorAll(".js-volume-popup.is-active").forEach((el) => {
          if (el !== volumePopup) el.classList.remove("is-active")
        })

        volumePopup.classList.toggle("is-active")
      })

      volumeRange.addEventListener("input", () => {
        audio.volume = volumeRange.value
      })

      document.addEventListener("click", (e) => {
        if (!volumeBtn.contains(e.target) && !volumePopup.contains(e.target)) {
          volumePopup.classList.remove("is-active")
        }
      })
    }
  })
}
